import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import longDarkLogo from '../../../../public/statics/images/logos/eon-logo-long-dark.png';
import longLogo from '../../../../public/statics/images/logos/eon-logo-long.png';
export const EONLogo = t0 => {
  const $ = _c(5);
  const {
    className,
    dark
  } = t0;
  const t1 = `${className || ""} ${dark ? "h-[18px] w-[50px]" : "h-[24px] w-[56px]"}`;
  const t2 = dark ? longDarkLogo : longLogo;
  const t3 = dark ? 50 : 56;
  const t4 = dark ? 18 : 24;
  let t5;
  if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3 || $[3] !== t4) {
    t5 = <Image priority={true} className={t1} src={t2} width={t3} height={t4} alt="Eon" />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  return t5;
};